/**
 * 業種の選択肢定数
 */
export const industryOptions = [
  { id: 'CONSTRUCTION', value: 'CONSTRUCTION', label: '建設業' },
  { id: 'MANUFACTURING', value: 'MANUFACTURING', label: '製造業' },
  { id: 'ELECTRICITY_GAS', value: 'ELECTRICITY_GAS', label: '電気・ガス' },
  {
    id: 'TRANSPORTATION_COMMUNICATION',
    value: 'TRANSPORTATION_COMMUNICATION',
    label: '運輸・通信業',
  },
  {
    id: 'WHOLESALE_RETAIL_FOOD',
    value: 'WHOLESALE_RETAIL_FOOD',
    label: '卸売・小売・飲食業',
  },
  {
    id: 'FINANCE_INSURANCE',
    value: 'FINANCE_INSURANCE',
    label: '金融・保険業',
  },
  { id: 'REAL_ESTATE', value: 'REAL_ESTATE', label: '不動産業' },
  { id: 'SERVICE', value: 'SERVICE', label: 'サービス業' },
  { id: 'EDUCATION', value: 'EDUCATION', label: '教育' },
  {
    id: 'AGRICULTURE_FORESTRY_FISHERY',
    value: 'AGRICULTURE_FORESTRY_FISHERY',
    label: '農林水産業',
  },
  { id: 'OTHER', value: 'OTHER', label: 'その他' },
];

/**
 * 上場ステータスの選択肢定数
 */
export const listingStatusOptions = [
  { id: 'PRIME', value: 'PRIME', label: 'プライム' },
  { id: 'STANDARD', value: 'STANDARD', label: 'スタンダード' },
  { id: 'GROWTH', value: 'GROWTH', label: 'グロウス' },
  { id: 'NONE', value: 'NONE', label: 'なし' },
];

/**
 * 法人車両保有ステータス
 */
export const CORPORATE_VEHICLE_OWNERSHIP_STATUS = {
  /** 契約車両が決定している(車両を既に保有している想定) */
  CONTRACT_VEHICLE_DECIDED: 'CONTRACT_VEHICLE_DECIDED',
  /** 契約車両未決定(車両を保有していない想定) */
  CONTRACT_VEHICLE_UNDETERMINED: 'CONTRACT_VEHICLE_UNDETERMINED',
  /** 車両を特定せず使用する(車両を既に保有している想定) */
  UNSPECIFIED_VEHICLE: 'UNSPECIFIED_VEHICLE',
} as const;

/**
 * 法人車両保有ステータス（選択肢）
 */
export const corporateVehicleOwnershipStatusOptions = [
  {
    value: CORPORATE_VEHICLE_OWNERSHIP_STATUS.CONTRACT_VEHICLE_DECIDED,
    label: '契約車両が決定している',
  },
  {
    value: CORPORATE_VEHICLE_OWNERSHIP_STATUS.CONTRACT_VEHICLE_UNDETERMINED,
    label: '契約車両未決定',
  },
  {
    value: CORPORATE_VEHICLE_OWNERSHIP_STATUS.UNSPECIFIED_VEHICLE,
    label: '車両を特定せず使用\n（社用車・従業員所有車のみ）',
  },
] as const;
